'use strict';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import {
  COOKIE_DURATION_ONE_YEAR,
  COOKIE_NAME_FOR_PREFERRED_LOCALE,
  setCookie
} from '@jspartials/cookie-utils';
import { pushOnDataLayer } from '@jspartials/gtm-utils';

const selector = {
  inputsCountry: '.js-country-selector'
};

const inputsCountry = document.querySelectorAll(selector.inputsCountry) || [];

/**
 * Update languages list
 */
const updateLanguages = (countrySelect) => {
  const currentCountryOptionElement =
    countrySelect.options[countrySelect.selectedIndex];
  const languagesList = JSON.parse(
    currentCountryOptionElement.dataset.languages
  );
  let newContentForLanguages = [];
  if (languagesList.length > 0) {
    languagesList.forEach((languageObject) => {
      newContentForLanguages.push({
        locale: languageObject.locale,
        url: languageObject.url,
        langname: languageObject.langname
      });
    });
  }
  updateSite(newContentForLanguages);
};

/**
 * Update site locale
 */
const updateSite = (languageSelect) => {
  // const currentLanguageOptionElement =
  //   languageSelect.options[languageSelect.selectedIndex];
  const selectedLenguage = languageSelect[0];
  const locale = selectedLenguage.locale;
  const url = selectedLenguage.url;
  launchGtmSiteLocaleChanged(locale);
  changeSite(locale, url);
};

/**
 * Update locale cookie and and site url
 */
const changeSite = (locale, url) => {
  setCookie(COOKIE_NAME_FOR_PREFERRED_LOCALE, locale, COOKIE_DURATION_ONE_YEAR);
  location.href = url;
};

const launchGtmSiteLocaleChanged = (locale) => {
  const dataLayerInfo = {
    event: 'eventTracking',
    category: 'Header',
    action: 'Click',
    label: `Top Menu | version selector | ${locale}`
  };

  pushOnDataLayer(dataLayerInfo);
};

document.addEventListener('DOMContentLoaded', function () {
  // Update languages and update site
  if (inputsCountry.length > 0) {
    inputsCountry.forEach((inputCountry) => {
      listenDOMEvent(inputCountry, 'change', function (event) {
        updateLanguages(event.target);
      });
    });
  }
});
